import { useState, useEffect } from 'react';
import { Card, Table, Pagination } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import PageHeader1 from '../../components/common/PageHeader1';
import EditButton from "../../components/common/EditButton";
import DeleteButton from "../../components/common/DeleteButton";
import apiClient from "../../utils/api";

function FeedbackList() {
    const [feedbacks, setFeedbacks] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [perPage] = useState(10);

    useEffect(() => {
        fetchFeedbacks();
    }, [currentPage]);

    const fetchFeedbacks = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get(`accounts/feedbacks?page=${currentPage}&per_page=${perPage}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setFeedbacks(response.data.data);
            setTotalPages(Math.ceil(response.data.total / response.data.per_page));
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error loading feedbacks');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this feedback?')) {
            return;
        }
        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.delete(`accounts/feedbacks/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Feedback deleted successfully');
            fetchFeedbacks();
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error deleting feedback');
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                <PageHeader1 
                    pagetitle='Feedbacks/Reviews' 
                    righttitle='Add Feedback' 
                    link='/accounts/feedback-add' 
                    routebutton={true}
                />
                <Card>
                    <Card.Body>
                        <Table responsive striped hover>
                            <thead>
                                <tr>
                                    <th>Ticket #</th>
                                    <th>Customer Name</th>
                                    <th>Contact</th>
                                    <th>Email</th>
                                    <th>Driver Rating</th>
                                    <th>Overall Rating</th>
                                    <th>Submit Date</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {feedbacks.map((feedback) => (
                                    <tr key={feedback.id}>
                                        <td>{feedback.ticket_number}</td>
                                        <td>{feedback.customer_name}</td>
                                        <td>{feedback.contact_number}</td>
                                        <td>{feedback.email}</td>
                                        <td>{feedback.driver_rating} ⭐</td>
                                        <td>{feedback.overall_rating} ⭐</td>
                                        <td>{new Date(feedback.created_at).toLocaleDateString()}</td>
                                        <td>
                                            <div className="btn-group" role="group">                                                <EditButton
                                                    to={`${process.env.PUBLIC_URL}/accounts/feedback-edit/${feedback.id}`}
                                                    className="btn btn-outline-secondary"
                                                    title="Edit Feedback"
                                                    permission="feedbacks.edit"
                                                >
                                                    <i className="fa fa-edit"></i>
                                                </EditButton>
                                                <DeleteButton
                                                    onDelete={() => handleDelete(feedback.id)}
                                                    className="btn btn-outline-danger"
                                                    title="Delete Feedback"
                                                    permission="feedbacks.delete"
                                                >
                                                    <i className="fa fa-trash"></i>
                                                </DeleteButton>
                                                <button 
                                                    type="button"
                                                    className="btn btn-outline-primary"
                                                    onClick={() => window.open(`/feedback-view/${feedback.id}`, '_blank')}
                                                    title="View Details"
                                                >
                                                    <i className="fa fa-eye"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <div className="d-flex justify-content-center mt-3">
                            <Pagination>
                                <Pagination.First 
                                    onClick={() => handlePageChange(1)} 
                                    disabled={currentPage === 1}
                                />
                                <Pagination.Prev 
                                    onClick={() => handlePageChange(currentPage - 1)} 
                                    disabled={currentPage === 1}
                                />
                                
                                {[...Array(totalPages)].map((_, idx) => (
                                    <Pagination.Item
                                        key={idx + 1}
                                        active={idx + 1 === currentPage}
                                        onClick={() => handlePageChange(idx + 1)}
                                    >
                                        {idx + 1}
                                    </Pagination.Item>
                                ))}
                                
                                <Pagination.Next 
                                    onClick={() => handlePageChange(currentPage + 1)} 
                                    disabled={currentPage === totalPages}
                                />
                                <Pagination.Last 
                                    onClick={() => handlePageChange(totalPages)} 
                                    disabled={currentPage === totalPages}
                                />
                            </Pagination>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default FeedbackList;